// import store from '@/store';
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/:catchAll(.*)', redirect: '/', },

  { path: '/', component: () => import('@/views/home.vue') },
  { path: '/errors', component: () => import('@/views/errorLog.vue') },

  { path: '/energy', component: () => import('@/views/monitor/powerManagementList.vue') },
  { path: '/energy/details', component: () => import('@/views/monitor/powerManagementListDetails.vue') },
  { path: '/tourMonitor', component: () => import('@/views/monitor/tourMonitor.vue') },
  { path: '/chargeMonitor', component: () => import('@/views/monitor/chargeMonitor.vue') },

  { path: '/calibration/ports', name: 'auth-ports', component: () => import('@/views/calibrations/portList.vue') },
  { path: '/tracking/system', name: 'auth-systems', component: () => import('@/views/tracking/systemTracking.vue') },
  { path: '/tracking/license', name: 'auth-license', component: () => import('@/views/tracking/license.vue') },
  { path: '/tracking/network', name: 'auth-network', component: () => import('@/views/tracking/network.vue') },
  { path: '/panel/tracking/follow', name: 'auth-plc', component: () => import('@/views/tracking/plcTracking.vue') },

  { path: '/tracking/components', name: 'auth-components', component: () => import('@/views/calibrations/componentControl.vue') }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  // const auth = to.name?.split('-')[0] == 'auth' ? true : false
  // if (auth) {
  //   if (store.state.auth.authority) next()
  //   else router.push('/')
  // }
  // else next()
  next()
});

export default router
